import printNotice from "@/pages/notice/printNotice";
import messageList from "@/pages/notice/messageList";
import layout from "@/components/layout/layout";
const noticeRouter = {
  path: "/notice",
  component: layout,
  meta: {
    roles: ["shop", "r4gys"],
    title: "公告中心",
    icon: "icon-tongzhigonggao"
  },
  children: [
    {
      path: "/notice/messageList",
      component: messageList,
      name: "message",
      meta: {
        roles: ["factory", "pingtai", "zhifa", "jgj", "r4gys", "shop"],
        title: "公告管理"
      }
    },
    {
      path: "/notice/printNotice",
      component: printNotice,
      name: "notice",
      meta: { roles: ["pingtai", "zhifa", "jgj", "r4gys"], title: "打印指导" }
    }
  ]
};
export default noticeRouter;



// WEBPACK FOOTER //
// ./src/router/modules/notice.js